import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {TOAST_TYPE} from "../../../../constants/Tpiq.constants";
import {ToastService} from "../../../../services/Toast.service";
import {Session} from "../../../../services/Session";

declare const _: any;

@Component({
  selector: 'app-suggest-fee',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './suggest-fee.component.html',
  styleUrl: './suggest-fee.component.scss'
})
export class SuggestFeeComponent implements OnInit, OnDestroy {
  @Input() clientTaxPlan: any;

  org: string = Session.getOrg();
  user: any = {};
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  // implementation fee fields
  implementationFeeTypes: Array<any> = [
    {type: 'Select All', priority: '', high: false, medium: false, low: false},
    {type: 'Intangible Benefits', priority: '', high: false, medium: false, low: false},
    {type: 'Urgency', priority: '', high: false, medium: false, low: false},
    {type: 'Complexity', priority: '', high: false, medium: false, low: false},
    {type: 'Risk', priority: '', high: false, medium: false, low: false}
  ];
  implementationFeeColumns: Array<any> = [
    {name: 'type', title: ''},
    {name: 'high', title: 'High'},
    {name: 'medium', title: 'Medium'},
    {name: 'low', title: 'Low'}];
  finalY1ImplementationValue: any;
  implementationValueExists: boolean = false;
  finalY2ImplementationValue: any;

  constructor(
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  setImplementationFeePriority(row, column) {
    row.priority = column.name;
    row[column.name] = true;
    if (column.name == 'high') {
      row.medium = false;
      row.low = false;
    } else if (column.name == 'medium') {
      row.high = false;
      row.low = false;
    } else if (column.name == 'low') {
      row.high = false;
      row.medium = false;
    }

    if (row.type == 'Select All') {
      _.each(this.implementationFeeTypes, (line) => {
        if (row.priority == 'high') {
          line.high = true;
          line.medium = false;
          line.low = false;
        } else if (row.priority == 'medium') {
          line.medium = true;
          line.high = false;
          line.low = false;
        } else if (row.priority == 'low') {
          line.low = true;
          line.high = false;
          line.medium = false;
        }
        line.priority = row.priority;
      });
    } else {
      _.each(this.implementationFeeTypes, (line) => {
        if (line.type == 'Select All') {
          line.priority = '';
          line.high = false;
          line.medium = false;
          line.low = false;
        }
      });
    }
  }

  calculateImplementationFee() {
    if (this.validateImplementationFeeLines()) {
      let avgValue: any;
      let percentSum = 0;
      _.each(this.implementationFeeTypes, (line) => {
        if (line.type !== 'Select All'){
          if (line.priority === 'high') {
            percentSum += 49.8;
          } else if (line.priority === 'medium') {
            percentSum += 33.2;
          } else if (line.priority === 'low') {
            percentSum += 24.9;
          }
        }
      });
      avgValue = percentSum / 4;
      if (this.clientTaxPlan && this.clientTaxPlan.year1Savings) {
        this.finalY1ImplementationValue = (this.clientTaxPlan.year1Savings * avgValue) / 100;
      } else {
        this.finalY1ImplementationValue = 0;
      }

      if (this.clientTaxPlan && this.clientTaxPlan.year2Savings) {
        this.finalY2ImplementationValue = (this.clientTaxPlan.year2Savings * avgValue) / 100;
      } else {
        this.finalY2ImplementationValue = 0;
      }

      this.implementationValueExists = true;
    } else {
      this.toastService.pop(TOAST_TYPE.error, 'Please select priority for any one type.');
    }
  }

  validateImplementationFeeLines() {
    let existValue = false;
    _.each(this.implementationFeeTypes, (line) => {
      if (line.priority) {
        existValue = true;
      }
    });
    return existValue;
  }

}
